<template>
    <div class="c2b-filter-information" v-if="filterSubmitted.isFilterFilled()">
        <p v-for="(prop, index) in filterProperties" 
            :key="index"
            v-show="shouldShowInfo(filterSubmitted, prop)">
            <span class="c2b-filter-information-label">{{prop.label}}: </span>
            <span>{{getFilterSubmittedInfo(filterSubmitted, prop)}}</span>
        </p>
    </div>
</template>

<script>
import { dateFilter, dateTimeFilter } from '@/utils/filters/DateTimeFilter'

export default {
    name: 'FilterInformationCmp',
    props: {
        filterSubmitted: {
            type: Object,
            default: new Object(),
        },

        // `filterProperties` and its possible object properties
        // type: string, list or daterange
        // label: left side naming for the information
        // property: which prop to access in given object
        // propertyInList: which prop to access in given object in a list
        filterProperties: {
            type: Array,
            default: [],
        },
    },
    methods: {
        getFilterSubmittedInfo(filterSubmitted, prop) {
            switch (prop.type) {
                case 'number':
                case 'string':
                    return filterSubmitted[prop.property]

                case 'object':
                    return filterSubmitted[prop.property][prop.propertyInObject]
                
                case 'list':
                    return filterSubmitted[prop.property].map((p) => p[prop.propertyInList]).join().replace(/,/g, ', ')

                case 'enumwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return ""
                    }

                    return filterSubmitted[prop.property].description

                case 'booleanwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return ""
                    }

                    return filterSubmitted[prop.property].description

                case 'date':
                    if (!filterSubmitted[prop.property]) {
                        return ""
                    }

                    return `${dateFilter(filterSubmitted[prop.property])}`

                case 'datetime':
                    if (!filterSubmitted[prop.property]) {
                        return ""
                    }

                    return `${dateTimeFilter(filterSubmitted[prop.property])}`

                case 'daterange':
                    if (!filterSubmitted[prop.property] || (!filterSubmitted[prop.property].start && !filterSubmitted[prop.property].end)) {
                        return ""
                    }

                    if (filterSubmitted[prop.property].start && filterSubmitted[prop.property].end) {
                        return `${dateFilter(filterSubmitted[prop.property].start)} até ${dateFilter(filterSubmitted[prop.property].end)}`
                    }

                    if (filterSubmitted[prop.property].start) {
                        return `Começando em ${dateFilter(filterSubmitted[prop.property].start)}`
                    }

                    if (filterSubmitted[prop.property].end) {
                        return `Até ${dateFilter(filterSubmitted[prop.property].end)}`
                    }

                    return false
                default:
                    throw new Error(`Unknown filter type: ${prop.type}`)
            }
        },
        shouldShowInfo(filterSubmitted, prop) {
            switch (prop.type) {
                case 'number':
                    return !!filterSubmitted[prop.property] || filterSubmitted[prop.property] === 0

                case 'string':
                    return !!filterSubmitted[prop.property].length

                case 'object':
                    return !!filterSubmitted[prop.property][prop.propertyInObject]
                
                case 'list':
                    return !!filterSubmitted[prop.property].length

                case 'enumwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return false
                    }

                    return !!filterSubmitted[prop.property].description.length

                case 'booleanwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return false
                    }

                    return !!filterSubmitted[prop.property].description.length

                case 'date':
                case 'datetime':
                    if (!filterSubmitted[prop.property]) {
                        return false
                    }

                    return true

                case 'daterange':
                    if (!filterSubmitted[prop.property]) {
                        return false
                    }

                    return !!filterSubmitted[prop.property].start || !!filterSubmitted[prop.property].end

                default:
                    throw new Error(`Unknown filter type: ${prop.type}`)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.c2b-filter-information {
    padding: 5px 10px;
    border: 1px solid #adb4b9;
    border-left: 3px solid #7f8b93;
    background-color: rgba(197, 141, 198, .05);
    margin-bottom: 16px;
    border-radius: 2px;

    .c2b-filter-information-label {
        text-transform: uppercase;
        font-weight: 600;
        color: #666;
        letter-spacing: 1px;
    }

    p {
        margin-bottom: 0;
    }
}
</style>
